// extracted by mini-css-extract-plugin
module.exports = {"root":"_1YSV3Qp","top":"_1ZPI-VW","bottom":"_1TIHrRD","savePrompt":"AwlnukP","form":"_3M3G44V","icon":"V4oJyuG","iconSvg":"_2ieBxZC"};
    if(module.hot) {
      // 1545369437512
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  